export enum BloomreachEventName {
  IbpVisitPage = 'Front_IB_Visit',
  IbpPartnerIdClick = 'Front_IB_PartnerID_Click',
  IbpQRClick = 'Front_IB_QR_Click',
  IbpRefLinkClick = 'Front_IB_RefLink_Click',
}